import { Component, OnInit } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { VenueModel } from '../../models/venues/venue.model';
import { CreateCapacityForVenuesComponent } from './create-capacity-for-venues/create-capacity-for-venues.component';
import { TranslateService } from "@ngx-translate/core";
import { VenueService } from '../../services/venues/venue.service';
import { Subject, takeUntil } from 'rxjs';
import { Router } from "@angular/router";

@Component({
  selector: 'app-venues',
  templateUrl: './venues.component.html',
  styleUrls: ['./venues.component.scss']
})
export class VenuesComponent implements OnInit {

  public listAllVenues: Array<VenueModel> = new Array<VenueModel>();
  public unsubscribe: Subject<void> = new Subject<void>();
  public imagePath: string = './assets/images/logo/venuelogo.png'
  public items: { [name: string]: MenuItem[] } = {};
  public spinner: boolean;
 
  constructor(
    public dialogService: DialogService,
    public venueService: VenueService,
    private messageService: MessageService,
    public translate: TranslateService,
    public router: Router
  ) {
  }


   ngOnInit():void {
    this.getAllVenues();
  }

  getAllVenues() {
    this.listAllVenues = new Array<VenueModel>();
    this.spinner= true;
    this.venueService.listvenues()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.spinner= false;
          this.listAllVenues = response;
        },
        error: errorResponse => {
          this.spinner= false;
          this.messageService.add({ severity: 'error', summary: "System error", life: 2000 });
        }
      });

  };

  createCapacityForVenue(event: MouseEvent, id: string, name: string) {
    event.stopPropagation();
    const ref = this.dialogService.open(CreateCapacityForVenuesComponent, {
      data: {
        id: id
      },
      header: name,
      width: '1000px'
    });
    ref.onClose.subscribe((item: any) => {
      if (item) {
        this.getAllVenues();
      }
    });
  }

  navigateToDivisions(id: string): void {
    this.router.navigate(['/venues', id, 'divisions']);
  }

}
